module.exports = __webpack_public_path__ + "static/media/man.d53c8f81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/man.png
// module id = 1685
// module chunks = 0